import { render, staticRenderFns } from "./clear-history-modal.vue?vue&type=template&id=5351ec2b&scoped=true&lang=pug&"
import script from "./clear-history-modal.vue?vue&type=script&lang=js&"
export * from "./clear-history-modal.vue?vue&type=script&lang=js&"
import style0 from "./clear-history-modal.vue?vue&type=style&index=0&id=5351ec2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5351ec2b",
  null
  
)

export default component.exports